import { ContentSyncCoordinator, type ContentSyncConfig, type SyncPassResult } from "./content-sync";
import { bonusReports } from "@/services/cache";
import { bonusReportsSyncKey } from "@/types/products/product-keys";
import type { ContentfulBonusReport, NormalizedContent } from "@tmi/types/entities";
import type { BonusReports } from "@tmi/types/api/content-models";

import { createDefaultLogger, LogLevels } from "@/types/console-logger";
const logger = createDefaultLogger( LogLevels.DEBUG );

const config: ContentSyncConfig<BonusReports, ContentfulBonusReport> = {
    name: 'bonus-reports',
    store: () => bonusReports,
    syncKey: bonusReportsSyncKey,
    metaRoute: 'content/bonus-report-catalog-meta',
    contentRoute: 'content/bonus-report-catalog',
    contentPageSize: 350,
    extractMetaPayload: ( data ) => data.bonusReportCatalog?.bonus_reports,
    extractContentPayload: ( data ) => data.bonusReportCatalog?.bonus_reports,
    normalizeItem: normalizeBonusReport
};

export class BonusReportsSyncCoordinator {
    readonly #inner: ContentSyncCoordinator<BonusReports, ContentfulBonusReport>;
    constructor() {
        this.#inner = new ContentSyncCoordinator( config );
    }
    patchRepository( authToken: string, force: boolean = false ): Promise<SyncPassResult> {
        return this.#inner.patchRepository( authToken, force );
    }
}

export function normalizeBonusReport( report: ContentfulBonusReport ): NormalizedContent | undefined {
    try {
        return {
            contentfulId: report.id,
            publishedDate: report.pub_dt,
            updatedDate: report.publish_at,
            slug: report.slug ?? undefined,
            title: report.name ?? undefined,
            pdfLink: report.pdf_uri ?? undefined,
            thumbnail: report.thumbnail_uri ?? undefined,
            authorId: undefined,
            adProductId: undefined,
            categoryIds: report.assoc_cat_ids ?? [],
            productIds: report.assoc_product_ids ?? [],
            sectorIds: [],
            tickerIds: []
        };
    } catch ( e: any ) {
        logger.error( `[ bonus-reports-sync-coordinator ] Failed to normalize bonus report '${ report.id }':`, e );
        return undefined;
    }
}
